'use client'

import type {ReactNode} from 'react'
import {useLayoutEffect} from 'react'
import {usePathname} from 'next/navigation'
import {useTheme} from './ThemeProvider'

interface LightModeOnlyProps {
    children: ReactNode
}

export function LightModeOnly({children}: LightModeOnlyProps) {
    const {forceTheme} = useTheme()
    const pathname = usePathname()

    useLayoutEffect(() => {
        const root = document.documentElement
        root.dataset.fitroForcedTheme = 'light'
        root.classList.remove('dark')
        root.classList.add('light')
        root.style.colorScheme = 'light'
        forceTheme('light')

        return () => {
            delete root.dataset.fitroForcedTheme
            forceTheme(null)
        }
    }, [forceTheme, pathname])

    return <>{children}</>
}
